import React from 'react';
/**
 * `DocTreeItem` is a wrapper around MUI `TreeItem` for rendering a document
 * node.
 *
 * Behaviour:
 * - When `item.path` is present, clicking the node opens the document link in a
 *   new tab using `window.open`.
 * - Shows a chevron end icon when `item.showIcon` is enabled.
 */

import { DocumentTreeItem } from '../common/CommonTypes';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeItem } from '@mui/x-tree-view';

type DocTreeItemProps = {
  item: DocumentTreeItem;
  children?: React.ReactNode;
};

const DocTreeItem = ({ item, children }: DocTreeItemProps): JSX.Element => {
  const onClick = () => {
    if (item.path) {
      window.open(item.path, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <TreeItem
      key={item.id}
      itemId={item.id}
      label={item.name}
      onClick={onClick}
      slots={{ endIcon: item.showIcon ? ChevronRightIcon : undefined }}>
      {children}
    </TreeItem>
  );
};

export default DocTreeItem;
